

const AdminDashbBoard = ()=>{
    return(<>
    <h1>Admin DashBoard</h1>
    </>)
}
export default AdminDashbBoard ; 